import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {LoadingService} from "../../services/loading.service";

@Component({
  selector: 'app-loader-emitter',
  templateUrl: './loader-emitter.component.html',
  styleUrls: ['./loader-emitter.component.scss']
})
export class LoaderEmitterComponent implements OnInit {

  @Output() loaderEventEmitter = new EventEmitter()
  constructor(private loadingService: LoadingService) { }

  ngOnInit(): void {
    this.loadingService.loading$.subscribe({
      next: result => {
        setTimeout(() => {
          this.loaderEventEmitter.emit(result)
        }, 0)
      }
    })
  }

}
